import { AxiosRequestConfig } from 'axios'
import { getLocalStorageItem } from '../localStorage'

export const shouldTrackRequest = (config: AxiosRequestConfig & { sendWhileOffline?: boolean }) =>
    config.method !== 'get' || config.sendWhileOffline

export const isUserError = (error: any): boolean => error.response?.status === 400

export const isOffline = (): boolean => {
    try {
        const value = getLocalStorageItem('isOffline')

        return value && JSON.parse(value)
    } catch (error) {
        return false
    }
}
